const PS_API_RESPONSE_MESSAGE_PATTERN =
  /\\?"ps_api_response_message\\?"\s*:\s*\\?"((?:\\.|[^"\\])*)\\?"/
const EMBEDDED_MESSAGE_PATTERN =
  /\\?"message\\?"\s*:\s*\\?"((?:\\.|[^"\\])*)\\?"/g

const normalizeEscapedMessage = (message: string): string => {
  let normalizedMessage = message

  for (let index = 0; index < 10; index += 1) {
    const nextMessage = normalizedMessage
      .replace(/\\\\/g, '\\')
      .replace(/\\"/g, '"')

    if (nextMessage === normalizedMessage) return normalizedMessage
    normalizedMessage = nextMessage
  }

  return normalizedMessage
}

const unescapeMessage = (message: string): string => {
  try {
    return JSON.parse(`"${message}"`)
  } catch {
    return message.replace(/\\"/g, '"').replace(/\\\\/g, '\\')
  }
}

const getErrorMessages = (error: unknown): string[] => {
  if (!error || typeof error !== 'object') return []

  const candidate = error as {
    graphQLErrors?: unknown
    message?: unknown
  }
  const graphQLErrorMessages = Array.isArray(candidate.graphQLErrors)
    ? candidate.graphQLErrors
        .map((graphQLError) =>
          graphQLError &&
          typeof graphQLError === 'object' &&
          'message' in graphQLError &&
          typeof graphQLError.message === 'string'
            ? graphQLError.message
            : undefined
        )
        .filter((message): message is string => Boolean(message))
    : []

  if (graphQLErrorMessages.length > 0) return graphQLErrorMessages
  return typeof candidate.message === 'string' && candidate.message
    ? [candidate.message]
    : []
}

const extractPsApiResponseMessage = (message: string): string | undefined => {
  const psApiResponseMatch = normalizeEscapedMessage(message).match(
    PS_API_RESPONSE_MESSAGE_PATTERN
  )
  return psApiResponseMatch?.[1]
    ? unescapeMessage(psApiResponseMatch[1])
    : undefined
}

const extractEmbeddedMessage = (message: string): string | undefined => {
  const embeddedMessages = [
    ...normalizeEscapedMessage(message).matchAll(EMBEDDED_MESSAGE_PATTERN)
  ]
  const innermostMessage = embeddedMessages.at(-1)?.[1]
  return innermostMessage ? unescapeMessage(innermostMessage) : undefined
}

export const getLaunchErrorDetails = (error: unknown): string | undefined => {
  const messages = getErrorMessages(error)
  if (messages.length === 0) return undefined

  const psApiResponseMessages = messages
    .map(extractPsApiResponseMessage)
    .filter((message): message is string => Boolean(message))
  if (psApiResponseMessages.length > 0) {
    return psApiResponseMessages.join('\n')
  }

  const embeddedMessages = messages
    .map(extractEmbeddedMessage)
    .filter((message): message is string => Boolean(message))

  return embeddedMessages.length > 0
    ? embeddedMessages.join('\n')
    : messages.join('\n')
}
